<template>
  <b-row>
    <b-col cols="12">
      <b-tabs content-class="mt-3">
        <b-tab title="Text" active>
          <b-tabs pills card vertical>
            <!-- Render Tabs, supply a unique `key` to each tab -->
            <b-tab
              @click="tabClick(data)"
              v-for="(data, index) in form.formTranslations"
              :key="index"
              :title="data"
            >
              <!-- translation form wrappe -->
              <div>
                <b-form-group id="input-group-2" label="File Title" label-for="input-2">
                  <b-form-input
                    @blur="addLanguageToField(data)"
                    id="input-2"
                    v-model="langugeLabel"
                    type="text"
                  ></b-form-input>
                </b-form-group>
                <b-form-group id="text-area" label="File Description" label-for="text-area">
                  <b-form-textarea
                    @blur="addLanguageToField(data)"
                    id="text-area"
                    v-model="langugeFileDescription"
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
              </div>
              <!-- <b-button
								class="btn btn-primary mt-3"
								@click="addLanguageToField(data)"
								variant="primary"
              >Update</b-button>-->
            </b-tab>
          </b-tabs>
        </b-tab>

        <!-- advacneee-------------------tab -->
        <b-tab title="Advanced" v-if="fieldData.inputType ==='file'">
          <b-row>
            <b-col cols="10">
              <b-form-checkbox
                class="text-left mb-3"
                v-model="uploadTitleTextIsDisabled"
                value="1"
                unchecked-value="0"
              >Disable upload title?</b-form-checkbox>
              <b-form-checkbox
                class="text-left mb-3"
                v-model="uploadDescriptionTextIsDisabled"
                value="1"
                unchecked-value="0"
              >Disable upload description?</b-form-checkbox>
            </b-col>
          </b-row>
          <div class="text-left">
            <b-col cols="6">
              <b-form-group>
                <b-form-checkbox class="mt-2" v-model="isMultipleUpload">Allow Multiple Uploads</b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-row v-if="isMultipleUpload" class="ml-1">
              <b-col cols="4">
                <b-form-group label="Maximum number of files">
                  <b-form-input type="number" v-model="maxUploads" placeholder="Number"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-col>
              <b-form-group label="Supported Formats">
                <b-form-checkbox-group
                  v-model="selectedFormats"
                  :options="fileFormats"
                  name="flavour-1a"
                ></b-form-checkbox-group>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Maximun file size ( in Mbs)">
                <b-form-input type="number" v-model="maxfileSize" placeholder="2"></b-form-input>
              </b-form-group>
            </b-col>
            <!-- <b-button
							class="btn btn-primary mt-3 ml-3"
							@click="setAdvanceSettingsForFile"
							variant="primary"
							:disabled="isLoading"
						>
							<b-spinner small v-if="isLoading"></b-spinner>Update
            </b-button>-->
          </div>
        </b-tab>

        <!-- advance  date tab -->
        <b-tab title="Advanced" v-if="fieldData.inputType === 'date'">
          <div @submit.stop.prevent class="text-left mt-4"></div>
        </b-tab>

        <!-- data validation -->
        <b-tab title="Validation">
          <div class="text-left">
            <b-col>
              <b-form-checkbox
                class="form-group col-md-6 ml-3"
                v-model="isRequireCheck"
                value="1"
                unchecked-value="0"
              >Is required?</b-form-checkbox>
            </b-col>

            <!-- <b-button
							class="btn btn-primary mt-3"
							@click="setValidation"
							variant="primary"
							:disabled="isLoading"
            >Update</b-button>-->
          </div>
        </b-tab>

        <!-- -------------------------------- -->
        <b-tab title="Conditional">
          <b-tabs pills card vertical>
            <!-- Render Tabs, supply a unique `key` to each tab -->
            <b-tab title="Simple">
              <b-col cols="12" class="mr-0">
                <b-form-checkbox
                  v-model="isConditional"
                  name="conditional"
                  value="1"
                  unchecked-value="0"
                >Is Conditional?</b-form-checkbox>
                <b-row v-if="isConditional==1">
                  <b-col cols="1">
                    <br />1
                  </b-col>
                  <b-col cols="6">
                    <label class="text-left">When Field</label>
                    <v-select
                      v-model="conditionalField"
                      class="mb-2"
                      :options="conditionalSectionElementLables"
                      lablel="label"
                      @input="getSelectedElement"
                    ></v-select>
                  </b-col>
                  <b-col cols="5">
                    <label class="text-left">Has value</label>
                    <v-select
                      class="mb-2"
                      label="text"
                      v-model="conditionalFieldValue"
                      :options="selectedElementOption"
                    ></v-select>
                  </b-col>
                </b-row>
              </b-col>

              <!-- <b-col cols="2 mt-3">
								<b-button variant="outline-primary" @click="setFieldConditions">Update</b-button>
              </b-col>-->
            </b-tab>
            <!-- <b-tab title="advanced"></b-tab> -->
          </b-tabs>
        </b-tab>
        <!-- <b-tab title="Custom CSS">
          <h3>Field CSS</h3>
          <codemirror v-model="fieldCSS" :options="cmOptions" @input="onCmCodeChange"></codemirror>
        </b-tab>
        <b-tab title="Custom JS">
          <h3>Field JS</h3>
          <codemirror v-model="fieldJS" :options="cmOptions" @input="onCmCodeChange"></codemirror>
        </b-tab>-->
      </b-tabs>
    </b-col>
    <!-- End of column -->
  </b-row>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { Helper } from "../helpers";
// language js
import "codemirror/mode/javascript/javascript.js";
// theme css
import "codemirror/theme/base16-dark.css";
import { EventBus } from "@/event-bus.js";
import uid from "uid";
import _ from "lodash";

export default {
  name: "AdvanceSettings",
  components: {},
  data() {
    return {
      uploadTitleTextIsDisabled: false,
      uploadDescriptionTextIsDisabled: false,
      conditionalSectionElements: [],
      conditionalSectionElementLables: [],
      selectedElementOption: [],
      conditionalField: null,
      conditionalFieldValue: null,
      fieldCSS: null,
      fieldJS: null,
      cmOptions: {
        // codemirror options
        tabSize: 4,
        mode: "Text/Css",
        theme: "Paraiso-Light",
        lineNumbers: true,
        line: true,
        height: 500
      },
      isConditional: this.fieldData.isConditional,

      condition: {},
      transalationLanguage: "english",

      langugeInput: undefined,
      langugeLabel: undefined,
      langugeFileDescription: undefined,
      langugeValidateMessage: undefined,

      isRequireCheck:
        this.fieldData.validation && this.fieldData.validation.required,

      // for file formats
      isMultipleUpload:
        (this.fieldData.configuration &&
          this.fieldData.configuration.isMultipleUpload) ||
        false,
      maxUploads:
        (this.fieldData.configuration &&
          this.fieldData.configuration.maxUploads) ||
        1,
      maxfileSize:
        (this.fieldData.configuration &&
          this.fieldData.configuration.maxfileSize) ||
        1,

      selectedFormats:
        (this.fieldData.configuration &&
          this.fieldData.configuration.selectedFormats) ||
        [],
      fileFormats: [
        { text: "PDF", value: "application/pdf" },
        { text: "MS Word", value: "application/msword" },
        { text: "Excel 2012", value: "application/vnd.ms-excel" },
        { text: "Power point", value: "application/vnd.ms-powerpoint" },
        { text: "Text", value: "text/plain" },
        { text: "Jpeg", value: "image/jpeg" },
        { text: "PNG", value: "image/png" }
      ]
    };
  },
  mounted() {
    this.uploadTitleTextIsDisabled = this.fieldData.uploadTitleTextIsDisabled;
    this.uploadDescriptionTextIsDisabled = this.fieldData.uploadDescriptionTextIsDisabled;

    (this.langugeInput = this.fieldData.label[this.transalationLanguage]),
      (this.langugeLabel = this.fieldData.label[this.transalationLanguage]),
      (this.langugeFileDescription = this.fieldData.fileDescription[
        this.transalationLanguage
      ]),
      this.getCurrentSectionList();
  },

  created() {
    EventBus.$on("onSaveSettings", value => {
      this.addLanguageToField(this.transalationLanguage);
      this.setAdvanceSettingsForFile();
      this.setFieldConditions();
      this.setValidation();
    });
  },

  computed: {
    ...mapGetters({ form: "form1" })
  },
  methods: {
    ...mapMutations(["TOGGLE_LOADER"]),

    getCurrentSectionList() {
      let conditionalSectionElements = this.form.formSection[this.sectionIndex]
        .formElements;
      conditionalSectionElements = conditionalSectionElements.filter(
        (element, index) => {
          if (
            element.inputType === "radio" ||
            element.inputType === "checkbox" ||
            element.inputType === "select"
          ) {
            // return element
            let dd = {
              label: element.label[this.transalationLanguage],
              element
            };
            return this.conditionalSectionElementLables.push(dd);
          }
        }
      );
      this.conditionalSectionElements = conditionalSectionElements;
      this.reRenderSavedConditions();
    },

    reRenderSavedConditions() {
      if (this.fieldData.conditions && this.fieldData.conditions.length) {
        this.conditionalField = this.fieldData.conditions[0].label;
        this.conditionalFieldValue = this.fieldData.conditions[0].value;
      }
    },

    getSelectedElement(selectedElement) {
      this.selectedElementOption = [];
      this.conditionalFieldValue = null;
      selectedElement.element.options.map(opt => {
        this.selectedElementOption.push(opt.value);
      });
    },

    tabClick(key) {
      this.transalationLanguage = key.toLowerCase();
      this.langugeInput = this.fieldData.label[this.transalationLanguage];
      this.langugeLabel = this.fieldData.label[this.transalationLanguage];
      this.langugeFileDescription = this.fieldData.fileDescription[
        this.transalationLanguage
      ];
    },

    addLanguageToField(language) {
      // console.log("addLanguageToField", language);

      let tempKey = language.toLowerCase();
      this.fieldData.label[tempKey] = this.langugeInput;
      this.fieldData.label[tempKey] = this.langugeLabel;
      this.fieldData.fileDescription[tempKey] = this.langugeFileDescription;
    },

    onCmReady(cm) {
      // console.log("the editor is readied!", cm);
    },

    onCmFocus(cm) {
      // console.log("the editor is focus!", cm);
    },

    onCmCodeChange(newCode) {
      this.fieldCSS = newCode;
      //this.updateFormCSS(this.formCSS);
    },

    setFieldConditions() {
      if (this.conditionalField && this.conditionalFieldValue) {
        let condition = {
          id: uid(),
          sourceFieldId: this.conditionalField.element.id,
          targetFieldId: this.fieldData.id,
          value: this.conditionalFieldValue,
          label: this.conditionalField.label
        };
        let dd = {
          id: this.conditionalField.element.id,
          isActive: false,
          value: this.conditionalFieldValue
        };
        let elements = [
          ...this.form.formSection[this.sectionIndex].formElements
        ];
        elements = elements.map(element => {
          if (element.options) {
            let found = element.options.map(opt => {
              if (
                opt.value === this.conditionalFieldValue &&
                this.conditionalField.element.id === element.id
              ) {
                element.conditionalFields.push(condition);
              }
            });
          }
        });
        this.fieldData.isConditional = this.isConditional;
        this.fieldData.isHidden = true;
        // Object.assign(this.fieldData, { condition });
        this.fieldData.conditions = [];
        this.fieldData.conditions.push(condition);
        this.conditionalFieldValue = null;
        this.conditionalField = null;
      } else {
      }
    },

    setValidation() {
      let validation = {
        required: this.isRequireCheck
      };
      Object.assign(this.fieldData, { validation });
    },

    setAdvanceSettingsForFile() {
      this.fieldData.configuration = {
        isMultipleUpload: this.isMultipleUpload,
        selectedFormats: this.selectedFormats,
        maxUploads: this.maxUploads,
        maxfileSize: this.maxfileSize
      };
      this.form.formSection[this.sectionIndex].formElements[
        this.fieldIndex
      ].uploadTitleTextIsDisabled = this.uploadTitleTextIsDisabled;
      this.form.formSection[this.sectionIndex].formElements[
        this.fieldIndex
      ].uploadDescriptionTextIsDisabled = this.uploadDescriptionTextIsDisabled;
      // Object.assign(this.fieldData, { advanceOption });
      // this.TOGGLE_LOADER(250);
    }
  },
  props: {
    fieldData: Object,
    sectionIndex: Number,
    fieldIndex: Number
  }
};
</script>
<style>
.cursor {
  cursor: pointer;
}
</style>

